module.exports = __webpack_public_path__ + "static/media/color-palette-4.ba6dd348.svg";